import { transformDateValue } from 'core/js/FormUtils';
export const getPharmasetView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let pharmasetList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Form Name","fieldValue":transformDataValue(data.formname,"string"), "fieldType":"string"},
              
              
            ],
            'dataList': [
                
              ]
          }

          pharmasetList.push(card);
  })
  return pharmasetList;
}